import { WidgetOptions } from '@sprinklr/stories/widget/WidgetOptions';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { SmartSize, XAxisDateFormats } from '@sprinklr/stories/widget/types';
import { observable } from 'mobx';
import { FontCase } from 'models/Theme/Theme';
import { DecimalFormat } from 'utils/Number/NumberUtils';
import { Borders } from './types';

export interface RankedTableWidgetOptions extends WidgetOptions {
    labelSize?: number;
    showRowSize?: boolean;
    rowSize?: number;
    showMetricValue?: boolean;
    showMetricName?: boolean;
    showMetricChange?: boolean;
    legacyMode?: boolean;
    autoRowHeight?: boolean;
    alignment?: any;
    rowNumbers?: boolean;
    columnNameFormat?: XAxisDateFormats;
    borders: Borders;
}

export class RankedTableWidgetOptionsImpl extends WidgetOptionsImpl
    implements RankedTableWidgetOptions {
    @observable labelSize = 20;
    @observable labelName = 'Row Name';

    @observable showAccountIcon = true;

    @observable showRowSize?: boolean = false;
    @observable rowSize?: number = 50;

    @observable showColumnName = true;
    @observable columnNameSize = 20;
    @observable columnNameFormat: XAxisDateFormats = 'auto';
    @observable dimensionSize = 15;

    @observable alignment = {
        rowName: 'left',
        columnName: 'center',
        metric: 'center',
    };

    @observable showMetricName = true;
    @observable metricNameSize = 13;
    @observable metricNameCase: FontCase = 'lowercase';
    @observable metricValueFormat: DecimalFormat = '1k';
    @observable metricValueCase: FontCase = 'lowercase';

    @observable showMetricValue = true;
    @observable metricValueSize = 50;

    @observable showMetricChange = true;
    @observable metricPercentChangeSize = 16;
    @observable highlightPercentChange: boolean;

    @observable rowNumbers = false;

    @observable showTimeRemainder = true;
    @observable orientation = 'vertical';
    @observable autoRowHeight = false;
    @observable invertDataSet = false;
    @observable smartSize: SmartSize = {
        enabled: false,
        mode: 'responsive',
        size: 'xl',
        baseline: {
            labelSize: 20,
            metricNameSize: 13,
            columnNameSize: 20,
            dimensionSize: 15,
            metricValueSize: 50,
            metricPercentChangeSize: 16,
        },
        optionDefaults: {},
        breakpoints: {},
    };
    @observable legacyMode = true;
    @observable borders: Borders = {
        top: {
            enabled: false,
            size: 20,
            color: '',
        },
        bottom: {
            enabled: false,
            size: 20,
            color: '',
        },
    };
}
